import React from 'react';

function Loading(props) {
  return (
    <div className='loader'>
      <div className="lds-facebook"><div></div><div></div><div></div></div>
    </div>
  );
}
export default Loading;